export default "__VITE_ASSET__K8lH2NJq__"